import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

const SlideoutStage = React.memo(({ children, className }) => (
  <div className={clsx(styles.megaMenu, className)}>{children}</div>
))

export default SlideoutStage
